import { render, staticRenderFns } from "./PrincipalTable.vue?vue&type=template&id=cee258ee&scoped=true"
import script from "./PrincipalTable.vue?vue&type=script&lang=js"
export * from "./PrincipalTable.vue?vue&type=script&lang=js"
import style0 from "./PrincipalTable.vue?vue&type=style&index=0&id=cee258ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee258ee",
  null
  
)

export default component.exports